import { GameSessionResult } from '../../../assets/enums/game-session.enum.ts';
import { type PerformanceTotals } from '../performance-api.ts';
import { centsToDollars, toCents, toPercent } from './money.ts';
import { type SessionsServiceSession } from './sessions-service-api.ts';

export const sumTotals = (completed: SessionsServiceSession[]): PerformanceTotals => {
  let won = 0;
  let wagersCents = 0;
  let payoutsCents = 0;

  completed.forEach((session) => {
    if (session.result === GameSessionResult.Won) won += 1;
    wagersCents += toCents(session.wager_amount);
    payoutsCents += toCents(session.final_payout);
  });

  const netCents = wagersCents - payoutsCents;

  return {
    sessions: completed.length,
    won,
    wagers: centsToDollars(wagersCents),
    payouts: centsToDollars(payoutsCents),
    net: centsToDollars(netCents),
    win_rate: toPercent(won, completed.length),
    payout_ratio: toPercent(payoutsCents, wagersCents),
  };
};
